<template>
  <div class="container">
    <div class="bg_wra">
      <h1>关于构思</h1>
      <h4>提供专业化定制解决方案</h4>
      <h4>深耕商业和资产管理、智慧园区、智慧公寓、智慧零售等领域</h4>
    </div>
    <div class="nav-warp">
      <div class="navigation solution_part">
        <div class="navigation-item"><a href="#a">企业介绍</a></div>
        <div class="navigation-item"><a href="#b">企业文化</a></div>
        <div class="navigation-item"><a href="#c">联系我们</a></div>
      </div>
    </div>
    <div class="solution_part" id="a">
      <div class="mobile-title">企业介绍</div>
      <a-row type="flex" class="introduce-warp">
        <a-col class="video-warp">
          <video
            src="https://ow-resource.gousii.com/video/video_%E8%8A%B1%E7%93%A3%E7%B4%A0%E6%9D%90_%E5%9F%8E%E5%9F%9F%E7%BD%91%E6%8A%80%E6%9C%AF_434456.mov"
            class="video" loop muted autoplay preload controls="controls" x-webkit-airplay="true" airplay="allow"
            webkit-playsinline="true" playsinline="true"></video>
        </a-col>
        <a-col class="mobile-warp">
          <h3>构思科技-智慧数字应用解决方案提供商</h3>
          <p>
            苏州构思网络科技有限公司是千城集团的全资子公司，是领先的系统解决方案和产品服务提供商。自公司成立以来，我们始终坚持技术创新与业务领域拓展，为客户提供前沿、高效、可靠的技术方案。
          </p>
        </a-col>
      </a-row>
    </div>
    <div class="culture-warp" id="b">
      <div class="solution_part">
        <div class="title">企业文化</div>
        <div class="subtitle">
          坚守诚信之本，不断追求卓越，与合作伙伴共同成长，为社会创造更多的价值。
        </div>

        <a-row :gutter="[35, 29]">
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="culture-item">
              <div class="item-left">
                <img src="https://ow-resource.gousii.com/image/culture1.png" alt="" />
                <p>使命</p>
              </div>
              <div class="culture-text">赋能企业，商业创新与进步，通过先进的技术解决方案，满足客户的真实需求，为社会创造持续的价值。</div>
              <img src="https://ow-resource.gousii.com/image/mission.png" class="bg" alt="" srcset="" />
            </div>
          </a-col>
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="culture-item">
              <div class="item-left">
                <img src="https://ow-resource.gousii.com/image/culture2.png" alt="" />
                <p>愿景</p>
              </div>
              <div class="culture-text">
                成为国内领先的技术解决方案提供商，领航行业的技术变革，为未来的智慧商业绘制蓝图。
              </div>
              <img src="https://ow-resource.gousii.com/image/wish.png" class="bg" />
            </div>
          </a-col>
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="culture-item">
              <div class="item-left">
                <img src="https://ow-resource.gousii.com/image/culture3.png" alt="" />
                <p>价值观</p>
              </div>
              <div class="culture-text">客户至上、技术创新、团队合作、诚信为本、社会责任。</div>
              <img src="https://ow-resource.gousii.com/image/value.png" class="bg" />
            </div>
          </a-col>
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="culture-item">
              <div class="item-left">
                <img src="https://ow-resource.gousii.com/image/culture4.png" alt="" />
                <p>经营理念</p>
              </div>
              <div class="culture-text">
                坚持技术创新与业务领域拓展，为客户提供前沿、高效、可靠的技术方案。
              </div>
              <img src="https://ow-resource.gousii.com/image/concept.png" class="bg" />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="relation-warp" id="c">
      <div class="solution_part">
        <div class="title padbot-41">联系我们</div>
        <a-row :gutter="[26, 29]">
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="relation-item mar-top22">
              <div>
                <div class="relation-header">
                  <img src="https://ow-resource.gousii.com/image/location-icon.png" class="icon1" alt="" />
                  <div>公司地址</div>
                </div>
                <div class="relation-text">
                  <span class="blue">苏州公司地址：</span>
                  苏州市工业园区裕新路同程大厦B栋706
                </div>
                <div class="relation-text">
                  <span class="blue">集团总部地址：</span>
                  上海市浦东新区五星路707弄12号
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="relation-item">
              <div>
                <div class="relation-header">
                  <img src="https://ow-resource.gousii.com/image/realation-icon2.png" class="icon" alt="" />
                  <div>产品咨询</div>
                </div>
                <div class="relation-text">
                  如果您对我们的方案感兴趣，想要深入了解、体验产品，请联系我们的产品咨询团队
                </div>
              </div>
              <div class="relation-bottom">
                联系电话：<span class="phone">156 0185 3960</span>
              </div>
            </div>
          </a-col>
          <a-col :span="12" :md="12" :sm="24" :xs="24">
            <div class="relation-item">
              <div>
                <div class="relation-header">
                  <img src="https://ow-resource.gousii.com/image/realation-icon2.png" class="icon" alt="" />
                  <div>售后服务咨询</div>
                </div>
                <div class="relation-text">
                  如果您在使用产品的过程中有任何疑问、建议或意见，欢迎向我们提出：
                </div>
              </div>
              <div class="relation-bottom">
                联系邮箱：<span class="blue2">yuanqixian@gousii.com</span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style lang="less" scoped>
.bg_wra {
  height: 480px;
  padding: 146px 0 0 120px;
  color: #fff;
  background: url("https://ow-resource.gousii.com/image%2F%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_449799bd-7975-4773-be94-465ce6ce4242.png") no-repeat center;
  background-size: 100% 100%;

  h1 {
    font-weight: 700;
    font-size: 50px;
    color: #fff;
  }

  h4 {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
  }
}

.solution_part {
  width: 1200px;
  margin: 0 auto;
}

.title {
  font-weight: 500;
  color: #3d3d3d;
  font-size: 30px;
  padding-top: 70px;
}

.subtitle {
  font-weight: 400;
  color: #3d3d3d;
  font-size: 16px;
  margin: 24px 0;
}

.mobile-title {
  display: none;
}

.nav-warp {
  border-bottom: 1px solid #eeeeee;

  .navigation {
    display: flex;
    height: 72px;
    line-height: 72px;
    padding: 0 120px;

    .navigation-item {
      font-size: 16px;
      margin-right: 70px;

      a {
        color: #3d3d3d;
      }

      a:hover {
        color: #1890ff;
      }
    }
  }
}

.introduce-warp {
  flex-wrap: nowrap;
  padding-bottom: 42px;
  background-color: #fff;

  .video {
    width: 442px;
    height: 256px;
    margin: 20px 48px 0 0;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
  }

  p {
    color: #3d3d3d;
    font-size: 16px;
  }
}

.culture-warp {
  background: #f6f7fb;
  padding-bottom: 86px;

  .culture-item {
    display: flex;
    align-items: center;
    color: #3d3d3d;
    font-size: 18px;
    background: #fff;
    padding: 34px 49px;
    position: relative;

    .bg {
      position: absolute;
      bottom: 0;
      left: 149px;
      // width: 208px;
      width: auto;
      height: 42px;
    }

    .item-left {
      margin-right: 45px;
    }

    img {
      height: 58px;
      width: 58px;
    }

    p {
      margin-top: 5px;
      text-align: center;
      color: #2d6ef6;
      font-size: 16px;
      white-space: nowrap;
    }
  }
}

.relation-warp {
  padding-bottom: 120px;

  .padbot-41 {
    padding-bottom: 41px;
  }

  .relation-item {
    padding: 37px 35px;
    background: #f2f4f8;
    height: 275px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .relation-header {
      display: flex;
      align-items: center;

      color: #3d3d3d;
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 27px;
    }

    .relation-text {
      font-weight: 400;
      color: #3d3d3d;
      font-size: 16px;
      margin-top: 12px;
    }

    .icon1 {
      width: 25px;
      height: 35px;
      margin-right: 10px;
    }

    .icon {
      height: 28px;
      width: 28px;
      margin-right: 10px;
    }

    .relation-bottom {
      margin-top: 40px;
    }
  }
}

@media screen and (max-width: 768px) {
  .solution_part {
    width: 100%;

    .title {
      font-weight: 500;
      color: #030d1e;
      font-size: 23px;
      padding-bottom: 16px;
      margin: 0 0 0 20px;
      position: relative;
      padding-top: 30px;
    }

    .title::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 30px;
      border: 2px solid #2d6ef6;
    }

    .subtitle {
      color: #404548;
      font-size: 15px;
    }
  }

  .nav-warp {
    .navigation {
      width: 100%;
      height: 46px;
      line-height: inherit;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 32px;

      .navigation-item {
        margin-right: 0;
      }
    }
  }

  .culture-warp {
    padding: 0 20px 22px 20px;

    .culture-item {
      padding: 26px 16px;
      align-items: flex-start;
      flex-direction: column;

      .culture-text {
        padding-left: 40px;
        font-size: 14px;
        color: #404548;
      }

      .item-left {
        display: flex;
        align-items: center;
        margin: 0 0 10px;

        img {
          height: 24px;
          width: 24px;
        }
      }

      p {
        margin: 0;
        margin-left: 16px;
        font-weight: 600;
        color: #2d6ef6;
        font-size: 17px;
      }

      .bg {
        left: 66px;
      }
    }
  }

  .introduce-warp {
    position: relative;

    .video-warp {
      display: none;
    }

    .mobile-warp {
      padding: 0 20px;

      h3 {
        font-size: 15px;
      }

      p {
        font-size: 14px;
      }

      .hint {
        font-weight: 600;
        color: #2d6ef6;
      }
    }
  }

  .introduce-warp::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 56px;
    width: 260px;
    height: 36px;
    background-image: url("https://ow-resource.gousii.com/image/about-mobile.png");
    background-size: 100% 100%;
  }

  .mobile-title {
    display: block;
    font-weight: 500;
    color: #030d1e;
    font-size: 23px;
    padding-bottom: 16px;
    margin: 30px 0 0 20px;
    position: relative;
  }

  .mobile-title::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30px;
    border: 2px solid #2d6ef6;
  }

  .relation-warp {
    margin: 0 20px;
    padding-bottom: 60px;

    .mar-top22 {
      margin-top: 22px;
    }

    .relation-item {
      padding: 26px 16px;
      height: auto;

      .relation-header {
        color: #030d1e;
        font-weight: 600;
        font-size: 17px;
        margin-bottom: 19px;
      }

      .relation-text {
        font-size: 14px;
        margin-top: 6px;
      }

      .blue {
        font-weight: 700;
        color: #0266ff;
      }

      .blue2 {
        font-weight: 700;
        color: #0266ff;
        font-size: 16px;
      }

      .phone {
        font-size: 16px;
        color: #404548;
        font-weight: 700;
      }

      .relation-bottom {
        font-size: 14px;
      }

      .icon1 {
        height: 26px;
        width: 22px;
      }
    }
  }

  .bg_wra {
    height: 260px;
    background: url("https://ow-resource.gousii.com/image%2F%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC-%E7%A7%BB%E5%8A%A8%E7%AB%AFbanner.png") no-repeat center;
    background-size: 100% 100%;
    padding: 94px 20px 0;

    h1 {
      font-size: 26px;
    }

    h4 {
      font-size: 14px;
    }
  }
}
</style>
